import { Col, Row } from "antd";
import { useState } from "react";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router";
import ItemModifierList from "./ItemModifierList";
import { getModifieresForItemApi } from "../../../api/itemModifiers";
import { AddEditItemModifier } from "./addEditModifier";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";
import { getmodifiersDropdown } from "../../../api/modifier";

const ItemModifier = () => {
  const [tableKey, setTableKey] = useState("");
  const [openItemModifier, setOpenItemModifier] = useState(false);
  const [paginatedModifiersComponent, setPaginatedModifiersComponent] =
    useState<any>();
  const { id } = useParams();
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [, setInitialValues] = useState({ isActive: undefined });

  const resetFilters = () => {
    getModifiers({
      itemid: id,
      q: "",
    }).then((res) => {
      setPaginatedModifiersComponent(res.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getModifiers({
      itemid: id,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedModifiersComponent(res.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getModifiers({
      itemid: id,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedModifiersComponent(res.data);
    });
  };

  const getModifiers = async (params: {
    itemid: string | number | undefined;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await ItemModifierMutation(params);
  };

  const {
    mutateAsync: ItemModifierMutation,
    isLoading: isItemModifierLoading,
  } = useMutation("ItemModifiers", getModifieresForItemApi);

  const [formatedItemModifier, setFormatedItemModifier] = useState<{}[]>();
  const { isLoading: loadingItemModifier } = useQuery(
    "getmodifiers",
    getmodifiersDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedItemModifier(
          res.data
            .map((modifier: any) => {
              if (modifier.isActive) {
                return { value: modifier.id, label: modifier.name };
              } else {
                return null;
              }
            })
            .filter((modifier: any) => modifier !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ isActive: res.data[0].id });
        }
      },
    }
  );

  return (
    <>
      <Row gutter={[10, 10]} style={{ width: "100%" }}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={() => {
              handleSearch();
            }}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>

        <Col
          offset={14}
          span={4}
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => setOpenItemModifier(true)} />
        </Col>
        <Col span={24}>
          <ItemModifierList
            ItemModifierMutation={ItemModifierMutation}
            paginatedModifiersComponent={paginatedModifiersComponent}
            setPaginatedModifiersComponent={setPaginatedModifiersComponent}
            search={search}
            filter={filter}
            isItemModifierLoading={isItemModifierLoading}
          />
        </Col>
      </Row>
      {openItemModifier && (
        <AddEditItemModifier
          loadingItemModifier={loadingItemModifier}
          formatedItemModifier={formatedItemModifier}
          itemid={id}
          openItemModifier={openItemModifier}
          setOpenItemModifier={setOpenItemModifier}
          filter={filter}
          search={search}
          ItemModifierMutation={ItemModifierMutation}
          setPaginatedModifiersComponent={setPaginatedModifiersComponent}
          ItemID={id}
        />
      )}
    </>
  );
};

export default ItemModifier;
